import React from 'react';
import IUniformNode, { deepenKey } from '../../../../../shared/quote-rendering/IUniformNode';
import { IBoldNodeProps } from '../../../../../shared/quote-rendering/UniformNodeFactory';

export default class BoldNode implements IUniformNode<React.ReactNode>{
    
    constructor(
        private readonly props: IBoldNodeProps<React.ReactNode>
    ) {}

    renderWithManualKey() {
        return <b key={this.props.key} style={this.props.style}>{this.props.children.map(x => x.renderWithManualKey())}</b>
    }

    render(seedKey: string){
        return <b key={seedKey} style={this.props.style}>{this.props.children.map((x,i) => x.render(deepenKey(seedKey, i)))}</b>
    }

}